import React, { useEffect, useState, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Box, Container, Typography, Paper, Button, CircularProgress } from '@mui/material';
import {
  CheckCircleOutline as OkIcon,
  ErrorOutline as ErrIcon,
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import { useAuthStore } from '../store/authStore';

const VerifyEmail = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const verifyEmail = useAuthStore((s) => s.verifyEmail);

  const [status, setStatus] = useState('loading'); // loading | ok | error
  const [message, setMessage] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // evita doble ejecución en StrictMode
    ran.current = true;
    if (!token) {
      setStatus('error');
      setMessage('Falta el enlace de verificación.');
      return;
    }
    verifyEmail(token).then((res) => {
      if (res.success) {
        setStatus('ok');
        setMessage(res.message || 'Correo verificado. Ya puedes iniciar sesión.');
      } else {
        setStatus('error');
        setMessage(res.error || 'El enlace es inválido o expiró.');
      }
    });
  }, [token, verifyEmail]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', py: 4 }}>
      <Container maxWidth="sm">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <Paper elevation={0} variant="outlined" sx={{ p: 4, borderRadius: 4, textAlign: 'center', bgcolor: 'background.paper' }}>
            {status === 'loading' && (
              <>
                <CircularProgress sx={{ mb: 2 }} />
                <Typography variant="h6">Verificando tu correo…</Typography>
              </>
            )}
            {status === 'ok' && (
              <>
                <OkIcon color="success" sx={{ fontSize: 56, mb: 2 }} />
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>¡Listo!</Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>{message}</Typography>
                <Button component={Link} to="/login" variant="contained" size="large">Iniciar sesión</Button>
              </>
            )}
            {status === 'error' && (
              <>
                <ErrIcon color="error" sx={{ fontSize: 56, mb: 2 }} />
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>No pudimos verificar</Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>{message}</Typography>
                <Button component={Link} to="/login" variant="outlined" size="large">Volver a iniciar sesión</Button>
              </>
            )}
          </Paper>
        </motion.div>
      </Container>
    </Box>
  );
};

export default VerifyEmail;
